import React from 'react';
import './../resources.css';
import {
    Row,
    Col,
    Select,
} from 'antd';
import {
   FaDownload
} from 'react-icons/fa';
import {connect} from "react-redux";
import {uzLanguage} from "../../../redux/actions/Uzlanguage";
import {ruLanguage} from "../../../redux/actions/RuLanguage";
import {enLanguage} from "../../../redux/actions/EnLanguage";
import {getManuals, getUsefulLinks} from "../../../api/config/Servises";
import {host, port} from "../../../api/host";
import Loader from "../../../commonComponents/loader/loader";


const { Option } = Select;

class Aids extends React.Component {
    state={
        aids:[],
        size:8,
        loading:true,
    };
    componentDidMount() {
        getManuals(0,this.state.size).then(res=>{
            if (res&&res.data&&res.data.content){
                this.setState({
                    aids:res.data.content,
                    loading:false,
                })
            }
        })
    }
    render() {
        const {uz,en}=this.props;
        const {aids,size}=this.state;
        const MoreManuals=()=>{
            this.setState({
                size:size+8,
            })
            getManuals(0,size).then(res=>{
                if (res&&res.data&&res.data.content){
                    this.setState({
                        aids:res.data.content,
                    })
                }
            })
        }
        return (
            <>
                <div className="videos_page">
                    <div className={"select_area"}>
                        <div>
                            <Select defaultValue="lucy" style={{ width: 120 }} onChange={''}>
                                <Option value="jack">{uz?"Eng mashhur":"Популярные"}</Option>
                                <Option value="lucy">{uz?"Eng so'nggi":"Последние"}</Option>
                                <Option value="Yiminghe">{uz?"Eng yangi":"Новые"}</Option>

                            </Select>
                        </div>
                    </div>

                    {
                        this.state.loading?<Loader/>:     <Row>
                            {
                                aids?aids.map(item=>{
                                    return <Col md={6} sm={12} xs={24}>
                                        <div className="videos-card"  data-aos={'zoom-in'}>
                                            <div className="w75">
                                                <div className="img-and-video">
                                                    <img src={host+':'+port+'/api/auth/file/'+item.logo.id} width={'100%'} alt=""/>
                                                </div>
                                                <p className={'video-title'} style={{textAlign:'center'}}>
                                                    {uz?item.titleUz.length>50?item.titleUz.slice(0,45)+'...':item.titleUz:item.titleRu.length>50?item.titleRu.slice(0,45)+'...':item.titleRu}
                                                </p>
                                                <p style={{color:'grey',textAlign:'center',fontSize:'18px'}}>
                                                    {item.pageCount} {uz?"bet":"стр."}
                                                </p>
                                                <a href={host+':'+port+'/api/auth/file/'+item.file.id} >
                                                    <p className="mainColor" style={{textAlign:'center',cursor:'pointer',fontSize:'18px'}}>
                                                        <ins><FaDownload/> {uz?"Yuklab olish":"скачать"}</ins>
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </Col>
                                }):""
                            }

                        </Row>
                    }

                    <div className="d-flex-center">
                        <button className="button mission-btn news-btn" onClick={MoreManuals}>
                            {uz?"Ko'proq ko'rsatish":"Показать еще"}
                        </button>
                    </div>
                </div>
            </>
        )
    }

}



const mapStateToProps = (state) => {

    return {
        uz: state.changeLang.uz,
        en: state.changeLang.en,
    };
};
export default connect(mapStateToProps,{uzLanguage,ruLanguage,enLanguage})(
    Aids
)